import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import { cookieAuth, login, logout } from '@/api/user'
import { getTagList } from '@/api/products'
import { getCategories } from '@/api/categories'
import router from '@/router'
import { getNotifications } from '@/api/system'

Vue.use(Vuex)

interface LoginParameters {
  username: string
  password: string
}
interface Language {
  name: string
  language_id: number
}
export default new Vuex.Store({
  state: {
    drawer: null,
    title: '',
    user: {
      id: null,
      name: {
        color: null,
        short: null,
        full: null
      },
      permissionlevel: null
    },
    //token: localStorage.getItem('token') || '',
    authorized: false,
    languageId: 2,
    availableLanguages: [],
    definedTags: [],
    categories: [],
    automaticProductNumber: true,
    automaticSEO: true,
    automaticSEOTitleAppend: 'Printshop',
    automaticSEODescriptionAppend: 'Modellbau, Modellbahn, Shop, Modellbau shop',
    notifications: []
  },
  getters: {
    authorized: state => {
      return state.authorized
    }
  },
  mutations: {
    setDrawer(state, active: boolean) {
      state.drawer = active
    },
    // setToken(state, value) {
    //   state.token = value
    // },
    setLanguages(state, languages) {
      state.availableLanguages = languages
    },
    setTags(state, tags) {
      state.definedTags = tags
    },
    setCategories(state, categories) {
      state.categories = categories
    },
    setNotifications(state, notifications) {
      state.notifications = notifications
    },
    setUser(state, { id, short, full, color }) {
      state.user.id = id
      state.user.name.short = short
      state.user.name.full = full
      state.user.name.color = color
    }
  },
  actions: {
    async cookieLogin(state) {
      const { data } = await cookieAuth()
      state.state.authorized = data.authenticated
      if (data.authenticated) {
        state.state.user = data.user
      }
    },
    async login(state, credentials: LoginParameters) {
      const response = await login(credentials.username, credentials.password)
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      if (response.data.successful) {
        // const token = response.data.accessToken
        // localStorage.setItem('token', token)
        // state.commit('setToken', token)
        // console.log(state.state.token)
        state.state.authorized = true
        state.state.user = response.data.user
      } else {
        state.state.authorized = false
        throw Error(response.data.error)
      }
    },
    logout(state) {
      // state.commit('setToken', '')
      // localStorage.setItem('token', '')
      state.state.authorized = false
      document.cookie = 'connect.sid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      logout()
      router.push('/')
    },
    async refreshTags(state) {
      const response = await getTagList()
      if (response.data) {
        state.commit('setTags', response.data)
      }
    },
    async refreshCategories(state) {
      const response = await getCategories()
      if (response.data) {
        state.commit('setCategories', response.data)
      }
    },
    async loadNotifications(state) {
      const answer = await getNotifications()
      if (answer.data.successful) {
        state.commit('setNotifications', answer.data.notifications)
      }
      // TODO: replace with Websocket connection later
      setTimeout(() => {
        state.dispatch('loadNotifications')
      }, 60 * 1000)
    }
  },
  modules: {}
})
